<template>
  <div>
    <page-header :title="$t('bill.budget_create')" />
    <page-body needMarginBottom>
      <a-steps class="steps" :current="currentTab">
        <a-step :title="$t('bill.budget_info')" />
        <a-step :title="$t('bill.budget_alert_info')" />
      </a-steps>
      <div class="content">
        <a-row :gutter="30">
          <a-col :md="{ span: 24 }" :lg="{ span: 22 }" :xl="{ span: 16 }" :xxl="{ span: 11 }">
            <step1 ref="step1Ref" :collapseActive="collapseActive" v-if="currentTab === 0" />
            <step2 ref="step2Ref" v-if="currentTab === 1" />
          </a-col>
        </a-row>
      </div>
    </page-body>
    <page-footer>
      <div slot="right">
        <a-button class="mr-3" type="primary" :loading="loading" @click="nextStep">{{ $t('dialog.ok') }}</a-button>
        <a-button @click="skipStep">{{ currentTab === 0 ? this.$t('dialog.cancel') : this.$t('common.skip')}}</a-button>
      </div>
    </page-footer>
  </div>
</template>

<script>
import Step1 from './components/Step1'
import Step2 from './components/Step2'

export default {
  name: 'BillBudgetCreate',
  components: {
    Step1,
    Step2,
  },
  data () {
    return {
      loading: false,
      currentTab: 0,
      collapseActive: [],
      currentBudget: {},
    }
  },
  created () {
    this.timer = null
  },
  destroyed () {
    clearTimeout(this.timer)
  },
  methods: {
    async validateStep1Form () {
      this.loading = true
      try {
        const { $refs: { step1Ref } } = this
        const values = await step1Ref.form.fc.validateFields()
        const params = {
          scope: this.$store.getters.scope,
          name: values.name,
          period_type: values.period_type,
          start_time: values.start_time.format('YYYY-MM-DD'),
          end_time: values.end_time.format('YYYY-MM-DD'),
          currency: values.currency.replace('_', '').replace('*'),
          amount: values.amount,
          brand: values.platform_brand,
          cloudaccount_id: values.account_id && values.account_id.key,
          cloudaccount: values.account_id && values.account_id.label,
          cloudprovider_id: values.cloudprovider_id && values.cloudprovider_id.key,
          cloudprovider_name: values.cloudprovider_id && values.cloudprovider_id.label,
          region_id: values.region_ext_id && values.region_ext_id.key,
          region: values.region_ext_id && values.region_ext_id.label,
          resource_type: values.resource_type,
          __meta__: values.tag,
        }
        if (values.domain) {
          params.scope = 'domain'
          params.domain_id_filter = values.domain
        }
        if (values.project) {
          params.scope = 'project'
          params.project_id_filter = values.project
        }
        if (values.currency.indexOf('_') !== -1) {
          params.exchanged_currency = values.currency.replace('_', '').replace('*', '')
          params.is_exchanged_currency = true
        }
        Object.keys(params).forEach(k => {
          if (!params[k] || params[k] === 'all') {
            delete params[k]
          }
        })
        if (values.tag) {
          params.match_all = values.match_all
        }
        const manager = new this.$Manager('budgets', 'v1')
        const res = await manager.create({
          data: params,
        })
        this.currentBudget = res.data
      } catch (error) {
        throw error
      } finally {
        this.loading = false
      }
    },
    async validateStep2Form () {
      this.loading = true
      try {
        const { $refs: { step2Ref } } = this
        const values = await step2Ref.validateFields()
        const data = {
          alerts: [
            {
              alert_threshold_type: values.alert_threshold_type,
              alert_threshold: values.alert_threshold,
              alert_frequency: values.alert_frequency,
              user_ids: values.recipients,
              channel: Array.from(new Set([...values.channel, ...(values.enabled_contact_types || [])])),
            },
          ],
        }
        new this.$Manager('budgets', 'v1').performAction({
          data,
          id: this.currentBudget.id,
          action: 'sync-alerts',
        })
      } catch (error) {
        throw error
      } finally {
        this.loading = false
      }
    },
    async nextStep () {
      this.loading = true
      if (this.currentTab === 0) {
        await this.validateStep1Form()
      } else if (this.currentTab === 1) {
        await this.validateStep2Form()
      }
      if (this.currentTab < 1) {
        this.currentTab += 1
      } else {
        this.timer = setTimeout(() => {
          this.$router.push('/budget')
        }, 500)
      }
      this.loading = false
    },
    skipStep () {
      this.$router.push('/budget')
    },
  },
}
</script>

<style lang="less" scoped>
  .steps {
    max-width: 750px;
    margin: 32px 0;
  }
</style>
